// Packages
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
// Helpers
import { ApiService } from '../api'
import { getInstance } from '../auth/auth0Plugin'
import { CError } from '../consoleMixin'

const KEY = 'V2_API'

const buildAxiosConfig = async (baseURL) => {
  const jwtToken = getInstance().getAccessToken()

  return {
    headers: {
      authorization: `Bearer ${jwtToken}`,
      agent: 'web',
      'content-type': 'application/json',
      frontendversion: process.env.VUE_APP_GIT_RELEASE_VERSION,
      indempotency: uuidv4(),
    },
    baseURL: baseURL,
  }
}

const emptyClient = {
  post: async () => {

  },

  delete: async () => {

  },

  patch: async () => {

  },

  get: async () => {

  },
}

export const getAxiosClient = async (pathURL) => {
  const config = await ApiService.getConfig({
    keys: KEY,
  })

  if (!config.data[KEY]) {
    CError('V2 API url not found. Using empty client')
    return emptyClient
  }

  const apiV2BaseUrl = config.data[KEY]
  return axios.create({
    ...await buildAxiosConfig(`${apiV2BaseUrl}/${pathURL}`),
  })
}
